import React from 'react';

import { Box } from '@rbilabs/universal-components';

import { StandardMobileHeader } from 'components/app-header/mobile-header';
import { useEnableNativeTabBarExperiment } from 'experiments/use-enable-native-tab-bar-experiment';
import { useIsDesktopWebBreakpoint } from 'hooks/use-media-query';
import Home from 'pages/home';
import useAuthFlow from 'state/auth/hooks/use-auth-flow';
import { t } from 'state/intl/translations';
import { useLoyaltyUserState } from 'state/loyalty/hooks/use-loyalty-user-state';
import { primitive } from 'styles/constants';

export default function HomeRoute() {
  const { triggerSignInAccessibility } = useAuthFlow();
  const signInAccessibilityMsg = triggerSignInAccessibility ? t('visuallyHiddenSignInSuccess') : '';
  const isDesktopWeb = useIsDesktopWebBreakpoint();
  // The native (Liquid Glass) tab bar has no header slot like the classic `Tabs`
  // screenOptions.header does, so this screen must render its own header when treatment is active.
  const { isTreatment: isNativeTabBarEnabled } = useEnableNativeTabBarExperiment();

  useLoyaltyUserState({ refreshOnMountOrFocus: true });

  return (
    <Box
      backgroundColor={primitive.$mayoEggWhite}
      flex={1}
      testID="homepage"
      accessibilityLabel={signInAccessibilityMsg}
      accessibilityRole="alert"
    >
      {isNativeTabBarEnabled ? (
        <StandardMobileHeader hideTsm={!isDesktopWeb} useNativeTabsRootSafeAreaInset />
      ) : null}
      <Home />
    </Box>
  );
}
